import clsx from "clsx"
import Image from "next/image"
import Link from "next/link"

import CardVideo from "./CardVideo"
import type { CardProps } from "./types/card"

const Card: React.FC<CardProps> = ({
  uri,
  linkClassName,
  mainImage,
  cardType,
  title,
  location,
  description,
  index,
}) => {
  if (
    cardType?.toLowerCase() === "video" &&
    (uri?.includes("youtube") || uri?.includes("vimeo"))
  ) {
    return (
      <CardVideo
        uri={uri}
        linkClassName={linkClassName}
        mainImage={mainImage}
        cardType={cardType}
        title={title}
        index={index}
      />
    )
  }

  return (
    <Link
      href={uri}
      className={clsx(
        "hover:opacity-80 ease-in-out transition-all duration-300",
        linkClassName,
      )}
    >
      <div className="rounded-lg aspect-video">
        <Image
          sizes="100vw"
          width={634}
          height={360}
          alt="card"
          src={mainImage}
          className="rounded-lg"
          priority={index <= 2}
        />
      </div>
      <div className="p-4 mt-4">
        {cardType && (
          <p className="mb-4 text-gray-30 caption3 md:caption2">{cardType}</p>
        )}
        <h2 className="heading2 text-gray-5">{title}</h2>
        {location && (
          <p className="mt-4 text-gray-30 caption3 md:caption2">{location}</p>
        )}
        {description && (
          <p className="mt-4 text-gray-2.5 body4">{description}</p>
        )}
      </div>
    </Link>
  )
}

export default Card
